<template>
    <v-container class="d-flex justify-center align-center pa-0 fill-height">
            <v-icon v-if="originalValue == null" color="primary" :icon="icon" class="cursor-pointer"/>
               <span v-else>{{ originalValue }}</span>
    </v-container>
</template>

<script setup>
import { onBeforeMount, ref } from 'vue';
import { mdiLinkVariant, mdiLinkVariantOff } from "@mdi/js";

const props = defineProps(['params']);

const icon = ref('');
const originalValue = ref(null);

onBeforeMount(() => {
if (typeof props.params.node != 'undefined' && props.params.node.rowPinned != 'bottom')
    if (!props.params.node.group && typeof props.params.data != 'undefined') {
        if ((props.params.data[props.params.colDef.field] != null && props.params.data[props.params.colDef.field] != '' || props.params.colDef.field == 'tokenECOS') && (props.params.colDef.field == 'tokenPSPFO' && props.params.pspUrl != '' || props.params.colDef.field != 'tokenPSPFO'))
            icon.value = mdiLinkVariant;

        // PSP NOT WORKING ON DEV
        if (props.params.colDef.field == 'tokenPSPFO' && props.params.pspUrl == '' && props.params.data[props.params.colDef.field] != null && props.params.data[props.params.colDef.field] != '')
            icon.value = mdiLinkVariantOff;
    }

    // FILTER VALUES
    else if (typeof props.params.value != 'undefined' && props.params.value != null && props.params.value != '') {
        if (props.params.value.length > 100)
            icon.value = mdiLinkVariant;

        // SELECT ALL
        else
            originalValue.value = props.params.value;
    }

    // EMPTY FILTER VALUE
    else
        icon.value = mdiLinkVariantOff;

// ROW PINNED BOTTOM
else
    originalValue.value = '';
});

</script>
